export var filterOptions = function (options, text) {
    return options.reduce(function (filteredIn, option) {
        var optionGroup = option;
        if (optionGroup.options) {
            var filteredInGroupOptions = filterOptions(optionGroup.options, text);
            if (filteredInGroupOptions.length > 0) {
                filteredIn.push({
                    label: optionGroup.label,
                    disabled: optionGroup.disabled,
                    options: filteredInGroupOptions
                });
            }
        }
        else if (matchSingleOption(option, text)) {
            filteredIn.push(option);
        }
        return filteredIn;
    }, []);
};
var matchSingleOption = function (option, text) {
    var searchableFields = ['value', 'label', 'description', 'labelTag'];
    var searchableTagFields = ['tags', 'filteringTags'];
    var searchText = text.toLowerCase();
    var searchStrFieldsFn = function (attr) { return matchString(option[attr], searchText); };
    var searchTagsFieldsFn = function (attr) {
        return option[attr] && option[attr].some(function (value) { return matchString(value, searchText); });
    };
    return searchableFields.some(searchStrFieldsFn) || searchableTagFields.some(searchTagsFieldsFn);
};
var matchString = function (value, searchText) {
    return value && value.toLowerCase().indexOf(searchText) !== -1;
};
//# sourceMappingURL=utils.js.map